export default "__VITE_ASSET__GkGDQ274__"